import { IHolding } from "../../holding"
import { IOmniaShell } from "../../shell"
import { IOmniaSession } from "../../types"
import { defineDirective } from "../../utils/angular"
import { isFunction } from "../../utils/utils"

/** @internal */
export class ContextDialogCtrl {

    static create(): ng.IDirective {

        return defineDirective(ContextDialogCtrl, "shared/main/context/dialog.html")

    }

    static $inject = ["$scope", "OmniaShell"]

    private close: Function
    private session: IOmniaSession

    holding: IHolding
    year: number

    selectYear: boolean


    constructor(private $scope: ng.IScope, private shell: IOmniaShell) {

        this.session = shell.getSession()

        const parentScope = $scope.$parent

        const options = parentScope.$parent["options"]

        if (options) {
            this.selectYear = options.selectYear
        }

        const close = parentScope["$close"]

        if (isFunction(close)) {
            this.close = () => close()
        }

    }

    $onInit() {
        this.holding = this.session.holding
        this.year = this.session.yearId
    }

    ok() {

        if (this.holding && this.year) {

            if (this.holding.HoldingId == this.session.holdingId) {

                if (this.session.selectYear(this.year)) {
                    this.shell.refresh(true)
                    this.close()
                }

            }
            else {

                this.session.selectHolding(this.holding, this.year).then(r => {

                    if (r) {
                        this.shell.reloadCurrentModule()
                    }

                    this.close()

                })

            }

        }

    }

    cancel() {
        this.close()
    }
}


